// extracted by mini-css-extract-plugin
export default {"container":"ve8by","icon":"z0vtl","text":"Viu13"};